"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersTableColumns = function (resources) { return [{
        dataField: 'displayName',
        text: resources.DisplayName,
        sort: true,
        style: {
            verticalAlign: 'middle'
        }
    }, {
        dataField: 'email',
        text: resources.Registration_Email,
        sort: true,
        style: {
            verticalAlign: 'middle'
        }
    }, {
        dataField: 'userRole',
        text: resources.Registration_Role,
        sort: true,
        style: {
            verticalAlign: 'middle'
        }
    }, {
        dataField: 'defaultLocation',
        text: resources.DefaultLocation,
        sort: true,
        style: {
            verticalAlign: 'middle'
        }
    }, {
        dataField: 'Actions',
        text: '',
        sort: false,
        style: {
            verticalAlign: 'middle'
        },
        headerStyle: {
            width: '20%'
        }
    }]; };
//# sourceMappingURL=UsersTableColumns.js.map